import registerTask from '../../../common/tasks/index';
// TODO
import presentationalComponent from './TaskPresentationalWrapper';
import containerComponent from './TaskContainer';

import { TOOLS } from '../../workspace/toolbar/toolbarConstants';

export default () =>
    registerTask({
        containerComponent,
        presentationalComponent,
        tools: [TOOLS.RICH_TEXT],
    });
